module.exports = __webpack_public_path__ + "static/media/firebase-cloud-firestore.76f10811.svg";